import { Link } from "react-router-dom";
import { PLANS, COMPARISON } from "../lib/funding";
import { Check, Minus, ArrowRight } from "lucide-react";

export default function FundingCompare() {
  const cell = (val) =>
    val ? <Check size={18} style={{ color: "var(--brass)" }} /> : <Minus size={16} style={{ color: "var(--ink-faint)", opacity: 0.5 }} />;

  return (
    <div data-testid="funding-compare-page" className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-32 pb-24">
      <div className="mb-16 reveal text-center">
        <p className="eyebrow mb-4">All Plans Compared</p>
        <h1 className="font-display text-6xl md:text-7xl mb-6 leading-[0.95]">Every feature, side by side.</h1>
        <p className="text-lg max-w-2xl mx-auto" style={{ color: "var(--ink-muted)" }}>
          Pick the plan that matches your stage. Upgrade or downgrade anytime.
        </p>
      </div>

      <div className="overflow-x-auto" style={{ border: "1px solid var(--hairline)" }}>
        <table className="w-full min-w-[800px]">
          <thead>
            <tr style={{ borderBottom: "1px solid var(--hairline-strong)" }}>
              <th className="text-left p-6 eyebrow" style={{ width: "40%" }}>Feature</th>
              <th className="text-center p-6">
                <p className="eyebrow mb-2">AI Report</p>
                <p className="font-display text-3xl" style={{ color: "var(--brass)" }}>$139</p>
                <p className="text-xs uppercase tracking-[0.2em]" style={{ color: "var(--ink-faint)" }}>one-time</p>
              </th>
              <th className="text-center p-6">
                <p className="eyebrow mb-2">WealthFirst PRO</p>
                <p className="font-display text-3xl" style={{ color: "var(--brass)" }}>$45</p>
                <p className="text-xs uppercase tracking-[0.2em]" style={{ color: "var(--ink-faint)" }}>/ month</p>
              </th>
              <th className="text-center p-6" style={{ background: "var(--surface)" }}>
                <p className="eyebrow mb-2" style={{ color: "var(--brass)" }}>★ AutoPilot</p>
                <p className="font-display text-3xl" style={{ color: "var(--brass)" }}>$91</p>
                <p className="text-xs uppercase tracking-[0.2em]" style={{ color: "var(--ink-faint)" }}>/ month · 7d trial</p>
              </th>
            </tr>
          </thead>
          <tbody>
            {COMPARISON.map((row, i) => (
              <tr key={row.feature} style={{ borderTop: i === 0 ? "none" : "1px solid var(--hairline)" }}>
                <td className="p-5 text-sm" style={{ color: "var(--ink)" }}>{row.feature}</td>
                <td className="p-5 text-center">{cell(row.ai_report)}</td>
                <td className="p-5 text-center">{cell(row.pro)}</td>
                <td className="p-5 text-center" style={{ background: "var(--surface)" }}>{cell(row.autopilot)}</td>
              </tr>
            ))}
            <tr style={{ borderTop: "1px solid var(--hairline-strong)" }}>
              <td className="p-6"></td>
              <td className="p-6 text-center">
                <Link to="/funding/apply?plan=ai_report" data-testid="cta-ai_report" className="btn-ghost !py-2 !px-4 inline-flex">
                  {PLANS.ai_report.cta} <ArrowRight size={12} />
                </Link>
              </td>
              <td className="p-6 text-center">
                <Link to="/funding/apply?plan=pro_monthly" data-testid="cta-pro" className="btn-ghost !py-2 !px-4 inline-flex">
                  {PLANS.pro.cta} <ArrowRight size={12} />
                </Link>
              </td>
              <td className="p-6 text-center" style={{ background: "var(--surface)" }}>
                <Link to="/funding/apply?plan=autopilot" data-testid="cta-autopilot" className="btn-brass !py-2 !px-4 inline-flex">
                  {PLANS.autopilot.cta} <ArrowRight size={12} />
                </Link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <p className="text-center text-xs uppercase tracking-[0.2em] mt-10" style={{ color: "var(--ink-faint)" }}>
        Cancel anytime · Downgrade anytime · No long-term contracts
      </p>
    </div>
  );
}
